import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  RowWrapper,
  Section,
  SectionTitle,
  UserFormProps,
} from '../../../components/AdminFormComponents';
import { useTranslation } from 'react-i18next';

export const AIUserFeaturesSection = (props: UserFormProps) => {
  const { t } = useTranslation();
  const {
    values,
    setFieldValue,
    isSubmitting,
    isAISpotlightEnabledForCustomer,
    isAIAssistantEnabledForCustomer,
  } = props;
  return (
    <Section id='aiUserFeaturesSection'>
      <SectionTitle>{t('AI')}</SectionTitle>
      <RowWrapper>
        {/* AI SPOTLIGHT (Flex Video) */}
        {isAISpotlightEnabledForCustomer && (
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='spotlightEnabled'
            label={t('AI Flex Video')}
            onChange={() => {
              setFieldValue('spotlightEnabled', !values.spotlightEnabled);
            }}
            disabled={isSubmitting}
          />
        )}
        {/* AI ASSISTANTS */}
        {isAIAssistantEnabledForCustomer && (
          <FormikSwitchField
            extendStyles={{ wrapper: { margin: '0 0 16px 0' } }}
            name='quickVideoAvatarEnabled'
            label={t('AI Video Agents')}
            onChange={() => {
              setFieldValue(
                'quickVideoAvatarEnabled',
                !values.quickVideoAvatarEnabled
              );
            }}
            disabled={isSubmitting}
          />
        )}
      </RowWrapper>
    </Section>
  );
};
